export default __webpack_public_path__ + "static/media/trans_mouth.f49a6584.png";